module.exports = __webpack_public_path__ + "static/media/uploading.ad0131a1.gif";